import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import login_logo from '../../../asset/img/login_logo_img.png';
import Typography from '../../../components/common/Typography';
import Button from '../../../components/common/Button';
import { LoginStyled } from '../../../asset/styled/LoginStyled';
import TextField from '../../../components/common/TextField';
import { getBirthLoginCheck } from '../loginSlice';
import { getAlertMessageFunction } from '../../../common/Util';

const BirthLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation('login');
  const { i18n } = useTranslation();
  const { t: tCommon } = useTranslation('common');
  const { isLogin } = useSelector(state => state.login);
  const searchParams = new URLSearchParams(location.search);
  const session = searchParams.get('key');
  const subUrl = searchParams.get('subUrl');
  const server = searchParams.get('server') || 'jan';
  if (server == 'payday') {
    sStorage.setItem('htmAlias', 'payday');
  }
  const [form, setForm] = useState({
    birth: '',
  });

  useEffect(() => {
    if (isLogin) {
      if (subUrl.includes('evDoc')) {
        navigate(`/evidenceDocuments/noHeader`);
      } else {
        if (subUrl.includes('rsQry')) {
          navigate('/resultQuery');
          return;
        }

        navigate(`/${subUrl}`);
      }
    }
  }, [isLogin]);

  const handleChange = e => {
    const { name, value } = e.target;
    let _value = value.replace(/[^0-9]/g, '');
    _value = _value.slice(0, 6);

    console.log('_value', _value);
    setForm({ ...form, [name]: _value });
  };

  const handleSubmit = () => {
    try {
      const alertMessage = getAlertMessageFunction();
      if (form.birth.length !== 6) {
        alertMessage(t('alertMessage07'));
        return;
      }
      dispatch(
        getBirthLoginCheck({
          htmBirthDay: form.birth,
          htmKey: session,
          htmAlias: server,
          htmFlag: 'M',
        }),
      );

      // const response = await dispatch(
      //   getBirthLoginCheck({
      //     htmBirthDay: form.birth,
      //     htmKey: session,
      //     htmAlias: server,
      //     htmFlag: 'M',
      //   }),
      // ).unwrap();
      // const { setLogin } = response;
      // if (setLogin == 'true') {
      //   const { htmsession, htmalias, htmpersabun } = response;
      //   state.status = 'success';
      //   state.isLogin = true;
      //   sStorage.setItem('sessionId', htmsession);
      //   sStorage.setItem('htmpersabun', htmpersabun);
      //   sStorage.setItem('htmAlias', htmalias || 'jan');
      // } else {
      //   // handleRejected(state, action, ['isLogin', 'status']);
      //   alertMessage(t('alertMessage02'));
      // }
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <LoginStyled>
      <div className="login_container">
        <div className="displayFlex" style={{ justifyContent: 'space-between' }}>
          <div>
            <Typography className="login_logo_text1">{t('header1')}</Typography>
            <Typography className="login_logo_text2">{t('header2')}</Typography>
          </div>
          <img src={login_logo} alt="login logo" width="145px" />
        </div>
        <div className="displayFlexColumn" style={{ gap: '10px' }}>
          <TextField
            placeholder={t('birthLogin')}
            variant="login"
            size="large"
            type="password"
            name="birth"
            value={form.htmComPass}
            onChange={handleChange}
          />
          <Button size="large" value={t('loginButton')} onClick={handleSubmit} />
        </div>
      </div>
    </LoginStyled>
  );
};

export default BirthLogin;
